var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5862 17.713C24.453 16.8274 25.1069 15.7562 25.4983 14.5805C25.8898 13.4047 26.0085 12.1553 25.8456 10.9269C25.6827 9.69846 25.2423 8.52321 24.5579 7.49017C23.8735 6.45712 22.963 5.59338 21.8953 4.96435C20.8276 4.33533 19.6308 3.95752 18.3955 3.85955C17.1602 3.76158 15.9188 3.94601 14.7653 4.39888C13.6118 4.85175 12.5765 5.56117 11.7378 6.47342C10.8991 7.38567 10.2791 8.47681 9.92453 9.66421H7.83619C6.70976 9.66408 5.61316 10.0263 4.70837 10.6972C3.80358 11.3682 3.13859 12.3124 2.81163 13.3903C2.48466 14.4682 2.51307 15.6228 2.89264 16.6833C3.27222 17.7439 3.98284 18.6542 4.91952 19.2799M14.2527 14.3309V24.8309M14.2527 24.8309L18.9194 20.1642M14.2527 24.8309L9.58602 20.1642",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.42ddf1726f0a5adbeac064c64b7a0fbb.svg";
export { ForwardRef as ReactComponent };